export default [
	{
		path: "/pros/service-charges",
		exact: true,
		policy: "providerAuth",
		component: "ServiceCharges",
		mui: true,
	},
];
